module.exports = __webpack_public_path__ + "img/Anhänger_O_A_2t.b858783f.svg";